import { Mail } from "lucide-react";

interface EmailInputWithButtonProps {
  placeholder?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  className?: string;
}

export const EmailInputWithButton = ({
  placeholder = "Your email address",
  buttonText = "GET STARTED",
  onButtonClick,
  className = "",
}: EmailInputWithButtonProps) => {
  return (
    <div className={`relative ${className}`}>
      {/* Email Input */}
      <div className="relative">
        <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="email"
          placeholder={placeholder}
          autoFocus
          className="w-full pl-12 pr-24 sm:pr-28 md:pr-32 py-3 sm:py-4 border border-gray-300 rounded-3xl ring-2 ring-blue-600 focus:ring-[#4169E1] focus:border-transparent bg-white text-gray-700 transition-colors text-sm sm:text-base"
        />

        {/* GET STARTED Button */}
        <button
          onClick={onButtonClick}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-blue-600 text-white rounded-3xl px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold 
          hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
          transition-colors duration-200 flex items-center space-x-1 sm:space-x-2 min-h-[32px] sm:min-h-[36px]"
        >
          <span>{buttonText}</span>
          <svg
            className="w-2.5 h-2.5 sm:w-3 sm:h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export const GetStartedButton = () => {
  return (
    <div className="">
      <div className="relative inline-block w-full group text-center">
        <a
          href="/dashboard/newsletter/setup"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="w-full  bg-blue-600 text-white rounded-3xl border-2 border-black py-3 sm:py-4 px-4 sm:px-2 text-base sm:text-lg font-semibold 
        hover:bg-blue-700 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        transition-all duration-200 mb-2
        min-h-[48px] touch-manipulation"
          >
            Claim Your Newsletter
          </button>
        </a>
        <span className="px-4 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm text-gray-500 text-center font-normal">
          No spam. Ever. • No credit card required
        </span>
      </div>
    </div>
  );
};

export const GetStartedButtonInverted = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative inline-block w-full group text-center">
        <a
          href="/dashboard/newsletter/setup"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="w-full md:max-w-sm lg:max-w-md bg-gray-800 text-white rounded-3xl border-2 border-black py-3 sm:py-4 px-4 sm:px-6 text-base sm:text-lg font-semibold 
        hover:bg-white hover:text-gray-800 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2
        transition-all duration-200 mb-2
        min-h-[48px] touch-manipulation"
          >
            Claim Your Newsletter
          </button>
        </a>
      </div>
      <span className="text-white px-4 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm text-center font-normal">
        No spam. Ever. • No credit card required
      </span>
    </div>
  );
};
